// compoents
import { FormElems, Alert, Accordion } from 'components';
import {
    MLE_CREATE_FORM_NAME,
    PREFIX_KYCURLS,
    BUSINESS_SECTION_TYPE_MLE,
    mleFields,
    FORM_TOAST_MSGS,
    ATLEAST_ONE,
} from './contants';
// Validator
import validate from './validator';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import MleInformation from './MleInformation';
import FileUploadField from '../../../FileUploadField';
import FakeLoader from '../../../FakeLoader';
import ImageViewModal from './ImageViewModal';
import { checkKycDocsEditable, handleDeleteFile, handleUploadKycImage, handleViewClick, isApproved, isSaveSubmitDisable, mleSubmitDataFormat, onNext, setInitialVerifiedData, VERIFIED, verifyUpdateFormChange } from '../mle.utils';
import { DOCUMENT_CATEGORY, EDITABLE_FIELD_KYC, GST, KYC_FILES, ONBOARDING_TYPE, PAN, SUBMITTED_KEY, UPDATE_FORMTYPES } from '../mle.constants';
import { resetSuccessKey, saveAndContinueRequestV1, submitRequestCallMle } from 'containers/MerchantLegalEntity/redux/merchantLegalEntity.actions';
import { UBO_SECTION_TYPE } from '../UobTab/constant';
import { toast } from 'react-toastify';
import { REQUIRED_MSG } from 'utils/constants/commonValues';

const BusinessTab = ({
    isViewMode,
    handleSubmit,
    actions,
    isEditMode,
    mutateFormData,
    merchantLegalEntityData,
    nextPath,
    invalid,
    checkerRemarks,
    uniqueIdentifier,
    initialIntentId,
    formType,
    sectionType,
    isReEditFlow,
    createdAt,
    isMakerFlow,
    eventType,
    isUpdate
}) => {
    
    const history = useHistory();
    const [intentId, setIntentId] = useState(initialIntentId);
    const [panDate, setPanDate] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [docUrls, setDocUrls] = useState({});
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [kycDocsList, setKycDocsList] = useState({
        mandatoryDocs: [],
        partialMandatoryDocs: []
    });
    const [kycListUpdated, setKycListUpdated] = useState(0);
    const [isPiiVerified, setIsPiiVerified] = useState({});
    const [editableCategories, setEditableCategories] = useState([]);
    const [infoMsgs, setInfoMsgs] = useState({});
    const [updateBtnCondFalse, setUpdateBtnCondFalse] = useState([]);
    const [isResetDocs, setIsResetDocs] = useState(false);
    const [kycDocsData, setKycDocsData] = useState({});
    const [docTimeStamp, setDocTimeStamp] = useState(null);

    const {formEvents} =  merchantLegalEntityData;
    const [currentGstValue, setCurrentGstValue] = useState("");
    useEffect(()=>{
        setCurrentGstValue(isPiiVerified?.[GST]?.documentDetails?.gstNumber?.value)
    },[isPiiVerified?.[GST]?.documentDetails?.gstNumber?.value])
    useEffect(() => {
        if (mutateFormData?.initial?.[PREFIX_KYCURLS])
            setKycDocsData(mutateFormData?.initial?.[PREFIX_KYCURLS]);
    }, [mutateFormData?.initial?.[PREFIX_KYCURLS]]);

    useEffect(()=>{
        const piiVerifiedData = setInitialVerifiedData({values: mutateFormData.values,fields: mleFields, checkerRemarks, isEditMode});
        
        // case where pan is not verified when the screen is opened
        if (piiVerifiedData?.[PAN]?.verifiedStatus !== VERIFIED) {
            actions.change(
                MLE_CREATE_FORM_NAME,
                mleFields.verifyPan.name,
                false
            );
        }
        setIsPiiVerified(piiVerifiedData);
    },[mutateFormData?.initial?.panDetails?.url, mutateFormData?.initial?.panDetails?.panNumber, mutateFormData?.initial?.gstUploadFile])
    useEffect(() => {
        // just for 
        actions.resetSuccessKey({section_type: UBO_SECTION_TYPE});
    }, []);

    useEffect(() => {
        
        if ((formEvents?.[BUSINESS_SECTION_TYPE_MLE] === SUBMITTED_KEY) && nextPath) {
            
            onNext(history, nextPath);
        } 
        return () => {
            if (formEvents?.[BUSINESS_SECTION_TYPE_MLE] === SUBMITTED_KEY && nextPath) {
                
                actions.resetSuccessKey({sectionType: BUSINESS_SECTION_TYPE_MLE});
            } 
        }
    }, [formEvents?.[BUSINESS_SECTION_TYPE_MLE]]);

    useEffect(() => {
        if (formEvents?.isFormSubmitted) {
            if (isReEditFlow)
                onNext(history, '/maker');
            if (isEditMode)
                onNext(history, '/mle-onboarding');
        } 

        return () => {
            if (isReEditFlow && formEvents?.isFormSubmitted) {        
                actions.resetSuccessKey({sectionType: BUSINESS_SECTION_TYPE_MLE});
            } 
        }
    }, [formEvents?.isFormSubmitted]);

    const prevValuesRef = useRef(mutateFormData.values);
    useEffect(() => {
        // not in case of create mle all other cases to be handled
        if (isEditMode || isReEditFlow || Object.keys(mutateFormData?.initial || {}).length > 0) {
            // Compare previous and current values
            
            if (JSON.stringify(prevValuesRef.current) !== JSON.stringify(mutateFormData.values)) {
                const infoMsgs = verifyUpdateFormChange(mutateFormData.initial, mutateFormData.values);
                const editableCategories = checkKycDocsEditable(checkerRemarks ?? {}, infoMsgs);

                setEditableCategories(editableCategories);
                actions.change(MLE_CREATE_FORM_NAME, "editedDocCategory", editableCategories);
                actions.change(MLE_CREATE_FORM_NAME, "infoMsgs", infoMsgs);
                setInfoMsgs(infoMsgs);

                

                // Update previous values ref
                prevValuesRef.current = mutateFormData.values;
            }
        }
    }, [mutateFormData.values]);

    useEffect(()=> {
        if (mutateFormData?.syncErrors?.[KYC_FILES] && mutateFormData?.values?.source != ONBOARDING_TYPE["axis"]) {
            const isUpdatedDocs = [
                ...new Set(
                  Object.values(mutateFormData?.syncErrors?.[KYC_FILES] || {})
                    .filter((value) => {
                      return (
                        value === ATLEAST_ONE(DOCUMENT_CATEGORY.POA) ||
                        value === ATLEAST_ONE(DOCUMENT_CATEGORY.POB) ||
                        value === ATLEAST_ONE(DOCUMENT_CATEGORY.POI)
                      );
                    })
                    .map((value) => {
                      if (value === ATLEAST_ONE(DOCUMENT_CATEGORY.POA)) {
                        return DOCUMENT_CATEGORY.POA;
                      } else if (value === ATLEAST_ONE(DOCUMENT_CATEGORY.POB)) {
                        return DOCUMENT_CATEGORY.POB;
                      } else {
                        return DOCUMENT_CATEGORY.POI;
                      }
                    })
                )
            ];


            setUpdateBtnCondFalse(isUpdatedDocs)
        } else {
            setUpdateBtnCondFalse([])
        }
    }, [mutateFormData?.syncErrors?.[KYC_FILES]], mutateFormData?.values)
    

    function handleSubmitForm(formData) {
        // formData.section = BUSINESS_SECTION;
        try {
            if (isEditMode || isReEditFlow) {
                handleUpdateClick(formData)
                return;
            }
            let updatedPayload = mleSubmitDataFormat({
                formData, 
                uniqueIdentifier, 
                intentId,
                formType, 
                sectionType
            });

            if (!updatedPayload) {
                // toast.error(FORM_TOAST_MSGS.IMPROPERDATA);
                return;
            }
            // let payload = mutateFormData;
            
            actions.saveAndContinueRequestV1(updatedPayload);
        } catch(e) {
            console.log("error while submitting the form");
        }
    }

    const handleUpdateClick = (formData) => {
        // create functionality -> Continue and submit currently both are together
        
        try {
            if (invalid) {
                return;
            }
            let payload = mleSubmitDataFormat({
                formData, 
                uniqueIdentifier: (isReEditFlow) ? uniqueIdentifier : `${uniqueIdentifier}.${Date.now()}`, 
                intentId,
                formType: UPDATE_FORMTYPES.business, 
                sectionType,
            });
            if (!payload) {
                return;
            }
            payload.isEditMode = !!isEditMode;
            payload.isReEditFlow = !!isReEditFlow;
            if (isReEditFlow) {
                payload.entityId = uniqueIdentifier.split('.')[0];
            } else {
                payload.entityId = uniqueIdentifier;
            }
            
            actions.submitRequestCallMle(payload);
            
        } catch(e) {
            console.log("handleSaveClick e", e);
        }
    }
    
    const isSubmitDisabled = useMemo(() => {
        return isSaveSubmitDisable(isPiiVerified, mutateFormData.values.businessType);
      }, [isPiiVerified?.[PAN]?.verifiedStatus, isPiiVerified?.[GST]?.verifiedStatus, isPiiVerified?.[GST]?.documentDetails?.gstNumber?.value, mutateFormData?.values?.businessType, currentGstValue]);
      
    return (
        <div className="merchant-legal-entity-onboarding-wrapper">
            <ImageViewModal
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
                timeStamp={docTimeStamp}
            />
            {isUploading ? <FakeLoader withMask /> : null}
            <h2 className="title">MLE Onboarding</h2>
            <form
                className="mle-onboarding-form"
                onSubmit={handleSubmit(handleSubmitForm)}
            >
               
                <Accordion
                    isOpened
                    isArrowIndicator
                    customClass="rounded-accordion"
                    upperComponent={
                        <h2 className="accordion-tile">MLE Information</h2>
                    }
                    lowerComponent={
                        <MleInformation 
                            mutateFormData={mutateFormData} 
                            setKycDocsList={setKycDocsList} 
                            setIsUploading={setIsUploading}
                            setSelectedDocument={setSelectedDocument}
                            setIsPiiVerified={setIsPiiVerified}
                            panDate={panDate}
                            setPanDate={setPanDate}
                            isPiiVerified={isPiiVerified}
                            checkerRemarks={checkerRemarks}
                            setIntentId={setIntentId}
                            intentId={intentId}
                            isViewMode={isViewMode}
                            setKycListUpdated={setKycListUpdated}
                            isEditMode={isEditMode}
                            infoMsgs={infoMsgs}
                            entityId={uniqueIdentifier}
                            isReEditFlow={isReEditFlow}
                            setIsResetDocs={setIsResetDocs}
                            createdAt={createdAt}
                            setDocTimeStamp={setDocTimeStamp}
                            isMakerFlow={isMakerFlow}
                            setCurrentGstValue={setCurrentGstValue}
                            eventType={eventType}
                            isUpdate={isUpdate}
                        />
                    }
                />

                {kycDocsList?.mandatoryDocs?.length > 0  && mutateFormData?.values?.source != ONBOARDING_TYPE["axis"] && <Accordion
                isArrowIndicator
                    customClass="rounded-accordion"
                    upperComponent={
                        <h2 className="accordion-tile">MLE KYC Document</h2>
                    }
                    lowerComponent={
                        <>
                            <ul className="form-list">
                                <li className="form-section">
                                    {kycDocsList?.mandatoryDocs?.map(item => {
                                        const multiDocs = (item?.maxDocCount === 1) ? true: false;
                                        return (
                                        <FileUploadField
                                            itemInfo={item}
                                            prefix={KYC_FILES}
                                            prefixReqName = {PREFIX_KYCURLS}
                                            handleUploadImageAndGetUrl={
                                                (file) => handleUploadKycImage(
                                                    file, 
                                                    setIsUploading, 
                                                    actions, 
                                                    (multiDocs) ? `${PREFIX_KYCURLS}.${item.docType}` : null,
                                                    MLE_CREATE_FORM_NAME,
                                                    isEditMode || isReEditFlow,
                                                    uniqueIdentifier,
                                                    item.docType || item.reqname
                                                )
                                            }
                                            handleViewClick={(docUrl) => {handleViewClick(docUrl, setIsUploading, setSelectedDocument, setDocTimeStamp, createdAt, merchantLegalEntityData?.formData?.checkoutMigrated)}}
                                            docUrls={docUrls}
                                            checkoutMigrated = {merchantLegalEntityData?.formData?.checkoutMigrated}
                                            setDocUrls={setDocUrls}
                                            actions={actions}
                                            change={change}
                                            checkerRemarks={checkerRemarks}
                                            handleDeleteFile={() => {handleDeleteFile(`${PREFIX_KYCURLS}.${item.docType}`, MLE_CREATE_FORM_NAME, actions)}}
                                            values = {mutateFormData?.initial ?? {}} // using as initial values here
                                            required = {true}
                                            clearedClicked={kycListUpdated}
                                            multi={(item?.maxDocCount === 1) ? false: true}
                                            formName={MLE_CREATE_FORM_NAME}
                                            isViewMode={isViewMode}
                                            isEditMode={isEditMode}
                                            isReEditFlow={isReEditFlow || isMakerFlow}
                                            isEditable={(!!(!isEditMode && !isReEditFlow) || 
                                                    !!(isEditMode && 
                                                    (Object.keys(checkerRemarks ?? {})?.includes(EDITABLE_FIELD_KYC) || 
                                                    editableCategories.includes(item.category || item.docCategory))) ||
                                                    (isReEditFlow && editableCategories.includes(item.docCategory || item.category))) ||
                                                    (isReEditFlow && !isApproved(checkerRemarks, `${PREFIX_KYCURLS}.${item.docType}`))
                                                }
                                            entityId={uniqueIdentifier}
                                            infoMsgs={infoMsgs}
                                            isReset={isResetDocs}
                                            initialValue={kycDocsData?.[item.docType]}
                                            defaultDate={createdAt}
                                        />
                                    )})}
                                    {kycDocsList?.partiallyMandatoryDocs?.length > 0 && 
                                    kycDocsList?.partiallyMandatoryDocs?.map(item => {
                                        const multiDocs = (item?.maxDocCount === 1) ? true: false;
                                        return (
                                        <FileUploadField
                                            itemInfo={item}
                                            prefix={KYC_FILES}
                                            prefixReqName = {PREFIX_KYCURLS}
                                            handleUploadImageAndGetUrl={
                                                (file) => handleUploadKycImage(
                                                    file, 
                                                    setIsUploading, 
                                                    actions, 
                                                    (multiDocs) ? `${PREFIX_KYCURLS}.${item.docType}` : null,
                                                    MLE_CREATE_FORM_NAME
                                                )}
                                            handleViewClick={(docUrl) => {handleViewClick(docUrl, setIsUploading, setSelectedDocument, setDocTimeStamp, createdAt,merchantLegalEntityData?.formData?.checkoutMigrated)}}
                                            checkoutMigrated = {merchantLegalEntityData?.formData?.checkoutMigrated}
                                            docUrls={docUrls}
                                            setDocUrls={setDocUrls}
                                            actions={actions}
                                            change={change}
                                            checkerRemarks={checkerRemarks}
                                            handleDeleteFile={() => {handleDeleteFile(`${PREFIX_KYCURLS}.${item.docType}`, MLE_CREATE_FORM_NAME, actions)}}
                                            values = {mutateFormData?.initial ?? {}}
                                            clearedClicked={kycListUpdated}
                                            multi={(item?.maxDocCount === 1) ? false: true}
                                            formName={MLE_CREATE_FORM_NAME}
                                            isViewMode={isViewMode}
                                            isEditMode={isEditMode}
                                            isReEditFlow={isReEditFlow || isMakerFlow}
                                            isEditable={(!!(!isEditMode && !isReEditFlow) || 
                                                    !!(isEditMode && 
                                                    (Object.keys(checkerRemarks ?? {})?.includes(EDITABLE_FIELD_KYC) || 
                                                    editableCategories.includes(item.category || item.docCategory))) ||
                                                    (isReEditFlow && editableCategories.includes(item.category || item.docCategory))) ||
                                                    (isReEditFlow && !isApproved(checkerRemarks, `${PREFIX_KYCURLS}.${item.docType}`))
                                                }
                                            infoMsgs={infoMsgs}
                                            isReset={isResetDocs}
                                            initialValue={kycDocsData?.[item.docType]}
                                            defaultDate={createdAt}
                                        />
                                    )})
                                    }
                                </li>
                                <li className="form-section action"></li>
                            </ul>
                        </>
                    }
                />}
                <div className="form-section action">
                    {
                        (!!isEditMode || !!isReEditFlow) && (
                            <FormElems.Button
                                id="next-btn"
                                buttonType="primary"
                                type="button"
                                handleClick={() => {
                                    if (updateBtnCondFalse.length > 0) {
                                        if (updateBtnCondFalse.length > 1) {
                                            toast.error(FORM_TOAST_MSGS.POABREQUIRED);
                                            
                                        } else if (updateBtnCondFalse.includes(DOCUMENT_CATEGORY.POA)) {
                                            toast.error(FORM_TOAST_MSGS.POAREQUIRED);
                                            
                                        } else {
                                            toast.error(FORM_TOAST_MSGS.POBREQUIRED);
                                            
                                        }
                                    }
                                    handleSubmit(handleSubmitForm)()
                                }}
                                text="Submit"
                                customClass={(invalid && updateBtnCondFalse.length === 0)?'disabled-mle-button':''}
                                isDisable={
                                    (!invalid && isSubmitDisabled) || 
                                    ((!!isEditMode || !!isReEditFlow) && Object.keys(infoMsgs).length === 0)
                                } // not invalid and pii button verified s
                            />
                        )
                    } 
                    {
                        (!isEditMode && !isReEditFlow) && (
                            <FormElems.Button
                                id="next-btn"
                                buttonType="primary"
                                type="button"
                                text="Continue"
                                customClass={(invalid)?'disabled-mle-button':''}
                                isDisable={isViewMode || 
                                    (!invalid && isSubmitDisabled) || 
                                    (Object.keys(infoMsgs).length === 0 && Object.keys(mutateFormData?.initial || {}).length > 0)}
                                handleClick={() => {
                                    if (mutateFormData?.syncErrors && JSON.stringify({...mutateFormData?.syncErrors, kycfiles: mutateFormData?.values?.source === ONBOARDING_TYPE["axis"] ? undefined : mutateFormData?.syncErrors?.kycfiles}).includes(REQUIRED_MSG)) {
                                        toast.error(FORM_TOAST_MSGS.REQUIRED);
                                        // return;
                                    }
                                    handleSubmit(handleSubmitForm)()
                                }}

                            />
                        )
                    }
                </div>
            </form>

            {merchantLegalEntityData.error &&
            merchantLegalEntityData.error.errorMessage ? (
                <Alert customClass="error-msg">
                    {merchantLegalEntityData.error.errorMessage}
                </Alert>
            ) : null}

            
        </div>
    );
};

BusinessTab.propTypes = {
    actions: PropTypes.object,
    isViewMode: PropTypes.bool,
    handleSubmit: PropTypes.func,
    isEditMode: PropTypes.bool,
    mutateFormData: PropTypes.object,
    initialValues: PropTypes.object,
    merchantLegalEntityData: PropTypes.object,
    staticData: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    form,
    staticData,
    merchantLegalEntityData,
}) => ({
    auth,
    mutateFormData: form[MLE_CREATE_FORM_NAME],
    staticData,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        saveAndContinueRequestV1,
        change,
        resetSuccessKey,
        submitRequestCallMle
    }, dispatch),
});

export default withRouter(
    compose(
        reduxForm({
            form: MLE_CREATE_FORM_NAME,
            enableReinitialize: true,
            validate,
            initialValues: {
                kycStatus: 'PENDING', // Default value here
            },
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(BusinessTab)
);
